import { useState } from "react";
import * as s from "styles/ModalCommonStyled";
import UserGroupRecorderList from "./UserGroupRecorderList";
import { SearchRecorderGroup } from "../SearcRecorderGroup";
import DebounceSearchInput from "components/atoms/input/search/DebounceSearchInput";
import Tabs from "components/atoms/tabs/Tabs";
import {
  UserGroupCURequest,
  UserGroupCUSystem,
} from "api/interfaces/userInterface.interface";

export type SearchRecorderProps = {
  accountId: string;
  onSelectedRowsChange: (
    selectedRows: NonNullable<UserGroupCURequest["systems"]>
  ) => void;
  onChangeCamera: (system: UserGroupCUSystem) => void;
  onSelectedGroupRowsChange: (selectedRows: number[]) => void;
  selectedRow?: UserGroupCURequest["systems"];
  selectedGroupRow?: number[];
  isDisabled: boolean;
  userId: string;
};

export interface DataRow {
  id: string;
  name: string;
  cameras: number;
  location: string;
}

const enum RECORDER_MENU {
  SYSTEMS = "systems",
  RECORDER_GROUPS = "recorderGroups",
}

export default function UserGroupRecorder(
  props: SearchRecorderProps
): JSX.Element {
  const [searchText, setSearchText] = useState<string>("");
  const onClickSearch = (keyword: string) => {
    setSearchText(keyword);
  };

  const recorderMenus = [
    {
      label: `Systems (${(props.selectedRow ?? []).length})`,
      value: RECORDER_MENU.SYSTEMS,
    },
    {
      label: `Recorder Groups (${(props.selectedGroupRow ?? []).length})`,
      value: RECORDER_MENU.RECORDER_GROUPS,
    },
  ];

  const [currentMenu, setCurrentMenu] = useState<RECORDER_MENU>(
    RECORDER_MENU.SYSTEMS
  );
  const onChangeMenu = (value: string) => {
    setCurrentMenu(value as RECORDER_MENU);
  };

  return (
    <>
      <s.ModalTabSearchWrapper>
        <Tabs
          tabs={recorderMenus}
          currentTab={currentMenu}
          onChangeTab={onChangeMenu}
        />
        <div className="search-box">
          {/* search input group, individual 공통으로 검색되도록 */}
          <DebounceSearchInput
            placeholder="Select Recorder"
            onClickSearch={onClickSearch}
          />
        </div>
      </s.ModalTabSearchWrapper>

      <s.ModalTableContainer>
        {currentMenu === RECORDER_MENU.SYSTEMS && (
          <UserGroupRecorderList
            accountId={props.accountId}
            search={searchText}
            selectedRow={props.selectedRow}
            onSelectedRowsChange={props.onSelectedRowsChange}
            onChangeCamera={props.onChangeCamera}
            isDisabled={props.isDisabled}
            userId={props.userId}
          />
        )}

        {currentMenu === RECORDER_MENU.RECORDER_GROUPS && (
          <SearchRecorderGroup
            accountId={props.accountId}
            search={searchText}
            selectedRecorderGroupRow={props.selectedGroupRow}
            onSelectedRowsChange={props.onSelectedGroupRowsChange}
            userId={props.userId}
            isDisabled={props.isDisabled}
          />
        )}
      </s.ModalTableContainer>
    </>
  );
}
